// Sports keywords for filtering Wikipedia content on the Home page

const sportsKeywords = [
    'sport', 'sports', 'athlete', 'athletics', 'athletic', 'olympiad', 'olympic', 'olympics',
    'championship', 'champion', 'tournament', 'competition', 'compete', 'medal', 'gold', 
    'silver', 'bronze', 'trophy', 'cup', 'league', 'season', 'final', 'finals', 'semifinal', 
    'semi-final', 'quarter-final', 'quarterfinal', 'playoff', 'play-off', 'team', 'coach',
    'football', 'footballer', 'soccer', 'fifa', 'world cup', 'premier league', 'la liga', 
    'bundesliga', 'serie a', 'ligue 1', 'champions league', 'uefa', 'euro', 'euros',
    'fa cup', 'copa america', 'messi', 'ronaldo', 'maradona', 'pele', 'pelé', 'beckham',
    'goal', 'goals', 'striker', 'midfielder', 'defender', 'goalkeeper', 'penalty', 'penalties',
    'hat-trick', 'hat trick', 'transfer', 'barcelona', 'real madrid', 'manchester', 'arsenal',
    'liverpool', 'chelsea', 'bayern', 'juventus', 'milan', 'inter', 'psg', 'ajax',
    'cricket', 'cricketer', 'test match', 'test cricket', 'one day', 'odi', 't20', 't-20',
    'twenty20', 'ipl', 'bcci', 'icc', 'world cup cricket', 'ashes', 'wicket', 'wickets',
    'century', 'centuries', 'batsman', 'batsmen', 'bowler', 'bowling', 'batting', 'innings',
    'sachin', 'bradman', 'kohli', 'tendulkar', 'dhoni', 'mumbai indians', 'chennai', 'delhi',
    'tennis', 'wimbledon', 'us open', 'french open', 'australian open', 'roland garros',
    'grand slam', 'atp', 'wta', 'federer', 'nadal', 'djokovic', 'serena', 'venus',
    'williams', 'serve', 'ace', 'love', 'deuce', 'match point', 'set', 'break point',
    'murray', 'sampras', 'agassi', 'borg', 'mcenroe', 'graf', 'navratilova',
    'basketball', 'nba', 'ncaa basketball', 'fiba', 'jordan', 'lebron', 'kobe', 'bryant',
    'dunk', 'three-pointer', 'three pointer', 'three-point', 'lakers', 'celtics', 'bulls',
    'warriors', 'rebound', 'assist', 'block', 'steal', 'magic', 'bird', 'shaq', 'curry',
    'baseball', 'mlb', 'world series', 'home run', 'homerun', 'pitcher', 'pitching',
    'batter', 'batting', 'strike', 'strikeout', 'yankees', 'red sox', 'dodgers', 'cubs',
    'giants', 'mets', 'astros', 'babe ruth', 'hank aaron', 'jackie robinson',
    'american football', 'nfl', 'super bowl', 'superbowl', 'touchdown', 'quarterback',
    'qb', 'patriots', 'cowboys', 'steelers', 'packers', 'gridiron', '49ers', 'chiefs',
    'raiders', 'brady', 'manning', 'montana', 'rice',
    'golf', 'golfer', 'masters', 'pga', 'tiger woods', 'rory mcilroy', 'open championship',
    'hole in one', 'birdie', 'eagle', 'bogey', 'putt', 'putting', 'par', 'nicklaus',
    'palmer', 'player', 'faldo', 'mickelson', 'spieth',
    'rugby', 'six nations', 'all blacks', 'world cup rugby', 'rugby union', 'rugby league',
    'try', 'conversion', 'scrum', 'line-out', 'springboks', 'wallabies', 'welsh',
    'hockey', 'nhl', 'stanley cup', 'ice hockey', 'field hockey', 'puck', 'goalie',
    'hat trick hockey', 'power play', 'gretzky', 'lemieux', 'orr', 'canadiens', 'maple leafs',
    'boxing', 'boxer', 'muhammad ali', 'mike tyson', 'tyson', 'mayweather', 'pacquiao',
    'heavyweight', 'lightweight', 'welterweight', 'knockout', 'ko', 'tko', 'punch', 'fight',
    'ufc', 'mma', 'mixed martial arts', 'wrestling', 'wrestler', 'wwe', 'cage', 'mcgregor',
    'holyfield', 'frazier', 'foreman', 'lewis', 'klitschko',
    'formula one', 'formula 1', 'f1', 'racing', 'race', 'grand prix', 'nascar',
    'schumacher', 'hamilton', 'verstappen', 'senna', 'pole position', 'pit stop', 'vettel',
    'monaco', 'silverstone', 'indianapolis', 'daytona', 'le mans', '24 hours', 'rally',
    'track and field', 'marathon', 'sprint', 'sprinter', 'relay', '100m', '200m', '400m',
    '100 metres', '200 metres', '800m', '1500m', '5000m', '10000m', 'hurdles', 'steeplechase',
    'long jump', 'high jump', 'triple jump', 'javelin', 'discus', 'hammer', 'shot put', 
    'pole vault', 'decathlon', 'heptathlon', 'bolt', 'usain', 'jesse owens', 'carl lewis',
    'michael johnson', 'mo farah', 'haile gebrselassie',
    'volleyball', 'swimming', 'swimmer', 'freestyle', 'butterfly', 'backstroke', 'breaststroke',
    'diving', 'diver', 'cycling', 'cyclist', 'tour de france', 'giro', 'vuelta', 'velodrome',
    'weightlifting', 'powerlifting', 'strongman', 'clean and jerk', 'snatch',
    'badminton', 'table tennis', 'ping pong', 'squash', 'snooker', 'billiards', 'darts',
    'martial arts', 'judo', 'karate', 'taekwondo', 'fencing', 'archery', 'shooting',
    'gymnastics', 'gymnast', 'vault', 'parallel bars', 'beam', 'floor exercise', 'pommel',
    'skateboarding', 'surfing', 'snowboarding', 'skiing', 'ski', 'winter olympics', 'slalom',
    'figure skating', 'speed skating', 'curling', 'bobsled', 'luge', 'skeleton',
    'rowing', 'sailing', 'yachting', 'kayaking', 'canoeing', 'triathlon', 'ironman',
    'equestrian', 'polo', 'horse racing', 'kentucky derby', 'melbourne cup',
    'stadium', 'arena', 'wembley', 'camp nou', 'madison square garden', 'yankee stadium',
    'old trafford', 'anfield', 'santiago bernabeu', 'maracana', 'allianz', 'fenway',
    'record', 'records', 'world record', 'victory', 'win', 'won', 'defeat', 'defeated',
    'title', 'titles', 'debut', 'retire', 'retirement', 'hall of fame', 'inducted',
    'mvp', 'most valuable player', 'rookie of the year', 'golden boot', 'golden ball',
    'ballon d\'or', 'ballon dor', 'player of the year', 'coach of the year', 'historic',
    'legendary', 'greatest', 'undefeated', 'streak', 'milestone'
];

export default sportsKeywords;
